export default "__VITE_ASSET__DRgmS_uM__"